import type { Article } from "./types";

export const societySystemsArticles: Article[] = [];
